export enum RolesStructureEnum {
  PRES = 'PRES',
  VICE_PRES = 'VICE_PRES',
  STAFF = 'STAFF',
  MANAGER = 'MANAGER',
  PLAYER = 'PLAYER',
  RECRUE = 'RECRUE',
}
